import axios from 'axios';

/**
 * Единый HTTP-клиент чатов. База — относительный `/chats` (в проде проксируется
 * nginx, в dev — devServer.proxy). У всех запросов есть таймаут, чтобы зависший
 * ответ не блокировал интерфейс навсегда.
 */
const api = axios.create({
  baseURL: '/chats',
  timeout: 15000,
});

/** Отдельный клиент для загрузки файлов: без таймаута (большие вложения). */
export const uploadApi = axios.create({
  baseURL: '/chats',
  timeout: 0,
});

export default api;
